import type { JSX } from "react";
import { fmtMs } from "../format";

export function ServiceCard({ name, state, latencyMs, detail }: {
  name: string; state: "up" | "down" | "degraded"; latencyMs: number | null; detail: string;
}): JSX.Element {
  const tone = state === "up" ? "ok" : state === "degraded" ? "warn" : "err";
  return (
    <div className={`cc-service cc-service-${tone}`}>
      <div className="cc-service-head"><span className="cc-dot" /><span className="cc-service-name">{name}</span></div>
      <div className="cc-service-meta">{latencyMs === null ? "—" : fmtMs(latencyMs)} · {detail}</div>
    </div>
  );
}
